// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
  display: inline-block;
  border: 3px solid #f3f3f3;
  border-radius: 50%;
  border-top: 3px solid #000;
  width: 15px;
  height: 15px;
  margin-left: 10px;
  margin-bottom: -3px; /* Safari */
  animation: spin 0.4s linear infinite;
}

/* Safari */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/spinner.scss"],"names":[],"mappings":"AAAA;EACC,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA,EACA,WAAA;EACA,oCAAA;AACD;;AAEA,WAAA;AAUA;EACC;IACC,uBAAA;EAAA;EAED;IACC,yBAAA;EAAA;AACF","sourcesContent":[".loader {\n\tdisplay: inline-block;\n\tborder: 3px solid #f3f3f3;\n\tborder-radius: 50%;\n\tborder-top: 3px solid #000;\n\twidth: 15px;\n\theight: 15px;\n\tmargin-left: 10px;\n\tmargin-bottom: -3px;\n\t-webkit-animation: spin 0.4s linear infinite; /* Safari */\n\tanimation: spin 0.4s linear infinite;\n}\n\n/* Safari */\n@-webkit-keyframes spin {\n\t0% {\n\t\t-webkit-transform: rotate(0deg);\n\t}\n\t100% {\n\t\t-webkit-transform: rotate(360deg);\n\t}\n}\n\n@keyframes spin {\n\t0% {\n\t\ttransform: rotate(0deg);\n\t}\n\t100% {\n\t\ttransform: rotate(360deg);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
